import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './roducers/index'

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
})
